import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'
import Root from './root.component'

import packageJson from '../package.json'

console.log(
    '%c' +
        packageJson.name +
        ' v' +
        packageJson.version +
        ' - ENVIRONMENT: ' +
        process.env.REACT_APP_ENV +
        ' - BUILD_TYPE: ' +
        process.env.NODE_ENV,
    'background: coral; color: black; font-size: 12px; padding: 5px;'
)

export const nodeEnv = process.env.NODE_ENV

export const envLinks = {
    '360°': process.env.STORE_360_URL,
    WHS: process.env.WHOLESALE_URL,
    SMRT: process.env.SMARTLY_URL,
    DP: process.env.DIGITAL_PORTAL_URL,
}

const lifecycles = singleSpaReact({
    React,
    ReactDOM,
    rootComponent: Root,
    errorBoundary(err, info, props) {
        // Customize the root error boundary for your microfrontend here.
        return null
    },
})

export const { bootstrap, mount, unmount } = lifecycles
